import React from 'react';
import {BsFillPlayFill, BsPauseFill} from 'react-icons/bs'
import { MdVideoCameraFront } from 'react-icons/md';
import {meal} from '../../constants'


import './Intro.css';

const Intro = () => {
    const  [playVideo, setPlayVideo] = React.useState(false)
    const vidRef = React.useRef();
    const handleVideo = () => {
      setPlayVideo((prevPlayVideo) => !prevPlayVideo)


      if(playVideo) {
        vidRef.current.pause();
      }else{
          vidRef.current.play()
      }
    }
  return(
  <div className='intro w-full h-screen relative md: sm:mt-0 -mt-32'>

    <video 
      src={meal}
      ref={vidRef}
      type="video/mp4"
      loop
      controls={false}
      muted
      className='h-full w-full relative object-cover'
    />
    <div className="div absolute inset-0 bg-[rgba(0,0,0,0.65)] left-0 right-0  flex justify-center items-center bottom-0 top-0">
      <div
      onClick={handleVideo}
       className="div w-24 h-24 rounded-full border border-white cursor-pointer flex justify-center items-center">
          {playVideo ? (
            <BsPauseFill color="#fff" fontSize={30}/>
          ) : <BsFillPlayFill color="#fff" fontSize={30}/> }
      </div>
    </div>
    
  </div>

  )
};

export default Intro;
